import React from "react";
import Avatar from "react-avatar";
import { MediaQuery, useMediaQuery } from "../../hooks/useMediaQuery";
import "./style.scss";
import { ICON_ARROWBACK } from "../../Icons";
const ChatUser = ({ users, onBack }) => {
  const isSM = useMediaQuery(MediaQuery.sm);
  return (
    <div className="Chat-user">
      {!isSM && (
        <div
          onClick={onBack}
          style={{
            cursor: "pointer",
          }}
        >
          <ICON_ARROWBACK />
        </div>
      )}
      <Avatar name={users[0].name} src={users[0].profileImg} size={50} round={true} />
      <div>
        <p
          style={{
            fontSize: "1.1rem",
            fontWeight: "700",
            color: "#1E1F23",
          }}
        >
          {users.map(user => user.name).join(',')}
        </p>
      </div>
    </div>
  );
};

export default ChatUser;
